import React, { Component } from "react";
import { Carousel, WingBlank, NavBar, Icon } from "antd-mobile";
import { Link } from "react-router-dom";

import { getLog } from "../../ajax/index.js";
import $ from "../../ajax/ajax";
import "./search.css";
import backImg from "../../assets/images/home/icon_img_back.png";
import homeImg from "../../assets/images/home/icon_img_home.png";
import { getCodeTableListByProductId } from "../../ajax/index";
import { createHashHistory } from "history";
const history = createHashHistory();

class productDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: ["1", "2"], // antd-mobile 的bug,这里必须要给个初始值。要是为空则不自动轮播了
      imgHeight: 176,
      listId: "",
      proDetail: {},
      productCode: "",
      inverter: "",
      compressorModel: "",
      motorModel: "",
      motorType: "",
      iskt: false,
    };
  }
  // 返回
  back(e) {
    history.goBack();
  }
  //错误列表
  goTab = () => {
    // 读取本地缓存语言 默认上一次选中语言
    let language = localStorage.getItem("language");
    if (!language) {
      //获取浏览器语言
      language = navigator.language.slice(0, 2);
    }
    // console.log(this.state.isgobycode, 'yyyyyyyyyyyyyyyyyyy', this.state.productCode)
    // if (this.state.isgobycode !== null && this.state.productCode) {
    //     history.push(`/errorCodeTable/${this.state.productCode}` + ',' + language + ',' + `p`);
    // }

    // else if (this.state.isgobycode === null && this.state.listId) {
    //     history.push("/errorCodeTable/" + this.state.listId + ',' + language)
    // }
    // else {
    //     history.push(`/systemerror`);
    // }
    history.push(
      "/errorCodeListByProduct/" +
        this.state.proDetail.productCode +
        "," +
        language
    );
  };
  getSize(data) {
    let img = document.getElementById(data);
    if (!img) return;
    let _height = img.clientHeight;
    let _width = img.clientWidth;
    if (_width >= _height) {
      img.style.marginTop = (375 - _height) / 2 + "px";
    } else {
      let num = (_width * 375) / _height;
      img.style.width = num + "px";
    }
  }

  // 获取productCategoryId
  // getProductCategoryId(id) {
  //   let _this = this;
  //   $.get({
  //     url: "/tsp/api/v1/system/error-code/errorCodeCategory/",
  //     data: { productCategoryId: id },
  //     guid: "errorCodeCategory",
  //   }).then((res) => {
  //     _this.setState({
  //       listId: res.data ? res.data.listId : "",
  //     });
  //   });
  // }
  componentDidMount() {
    // 产品id /api/v1/product/img/thumbnail/{productId}
    const productId = this.props.match.params.id;

    // this.getdocs(productId);
    //获取产品详情
    this.getProdetial(productId);
  }
  //获取产品详情
  getProdetial(productId) {
    let _this = this;
    $.get({
      url: `/tsp/ibos/web//tspApi/product/customer/getById?productId=${productId}`,
      guid: "productCustomer",
    }).then((res) => {
      _this.setState({
        proDetail: res.data,
        productCode: res.data.productCode,
        inverter: res.data.inverter,
        compressorModel: res.data.compressorModel,
        motorModel: res.data.motorModel,
        motorType: res.data.motorType,
      });
      if (
        res.data.parentCategoryNameCn &&
        res.data.parentCategoryNameCn.indexOf("空调") > -1
      ) {
        this.setState({
          iskt: true,
        });
      } else {
        this.setState({
          iskt: false,
        });
      }
      // getCodeTableListByProductId(res.data.productId).then((res) => {
      //   this.setState({
      //     isgobycode: res.data || null, //判断是否是根据productcode配置故障代码表
      //   });
      // });
      // this.getProductCategoryId(res.data.categoryId);
      this.getdocs(res.data.productId);
      let currentUrl = window.location.href;
      let appId = "tsp.errorcode";
      let pointName = `/productDetail`;
      getLog(currentUrl, appId, pointName);
    });
  }
  //获取产品轮播图
  getdocs(productId) {
    let _this = this;
    let _data = [];
    $.get({
      url: `/tsp/ibos/web//tspApi/productImage/thumbnail/getByProductId?productId=${productId}`,
      showError: true,
      guid: "thumbnail",
    }).then((res) => {
      _data = res.data.length ? res.data : ["errcode-image"];
      _this.setState({
        data: _data,
      });
    });
  }

  render() {
    // console.log('yyyyyyyyyyyyyyy', sessionStorage.getItem("barcodeHidden"))
    // let str=this.state.motorModel;
    // console.log(str.replace(/(^\s*)|(\s*$)/g, "").slice(0, 1))
    return (
      <div className="transition-item detail-page">
        <div className="productDetail">
          <div className="goback bg-f4f6f9">
            <NavBar
              mode="light"
              icon={
                <img
                  key="1"
                  src={backImg}
                  width="32"
                  height="32"
                  alt="backImg"
                />
              }
              onLeftClick={this.back}
              rightContent={[
                <Link key="2" to="/">
                  <img
                    key="1"
                    src={homeImg}
                    width="32"
                    height="32"
                    alt="homeImg"
                  />
                </Link>,
              ]}
            ></NavBar>
          </div>
          {/*this.state.data.map((val) => src={getDocDownloadUrl(val)}*/}
          <WingBlank>
            <div className="carousel-vertical">
              <Carousel dots={this.state.data.length > 1}>
                {this.state.data.map((val) => {
                  let loadfail = require("../../assets/images/home/img_null.png");
                  return (
                    <img
                      // src={getDocDownloadUrl(val)}   //暂时隐藏图片展示
                      src={loadfail}
                      alt="tupan"
                      key={val}
                      id={val}
                      style={{
                        width: "100%",
                        verticalAlign: "top",
                        marginTop: "0px",
                      }}
                      onError={() => {
                        document.getElementById(val).src = loadfail;
                      }}
                      onLoad={() => {
                        window.dispatchEvent(new Event("resize"));
                        this.setState({ imgHeight: "auto" });
                        this.getSize(val);
                      }}
                    />
                  );
                })}
              </Carousel>
            </div>
          </WingBlank>

          <ul className="parameter-list ">
            {/*
                            第一个，和第二个入口没有该值
                        */}
            {sessionStorage.getItem("barcodeHidden") === "1" ? (
              ""
            ) : (
              <li>
                <span className="parameter-key">Barcode：</span>
                <span className="parameter-val">
                  {sessionStorage.getItem("barcode")}
                </span>
              </li>
            )}
            {/*
                            <li>
                                <span className="parameter-key">Brand：</span>
                                <span className="parameter-val">{this.state.proDetail ? this.state.proDetail.brand : ''}</span>
                            </li>
                        */}
            <li>
              <span className="parameter-key">Product Model：</span>
              <span className="parameter-val">
                {sessionStorage.getItem("customerModel")}
              </span>
            </li>
            {this.state.iskt ? (
              <div>
                <li>
                  <span className="parameter-key">Inverter or ON/OFF：</span>
                  <span className="parameter-val">{this.state.inverter}</span>
                </li>
                <li>
                  <span className="parameter-key">Compressor model：</span>
                  <span className="parameter-val">
                    {this.state.compressorModel}
                  </span>
                </li>
                <li>
                  <span className="parameter-key">Motor model：</span>
                  <span className="parameter-val">{this.state.motorModel}</span>
                </li>
                <li>
                  <span className="parameter-key">Motor type：</span>
                  <span className="parameter-val">{this.state.motorType}</span>
                </li>
              </div>
            ) : (
              ""
            )}
          </ul>

          <div className="code-btn-content">
            <button onClick={this.goTab} className="code-btn">
              Error Code
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default productDetail;



// WEBPACK FOOTER //
// ./src/pages/search/productDetail.js